import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import * as actions from "../actions/project";
import TextField from "@material-ui/core/TextField";
import ImageUploader from "react-images-upload";
import { CardsProjects } from "../components";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { AppBar, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  Button: {
    background: "linear-gradient(45deg, #1c7ff4 30%, #45adf7)",
    margin: theme.spacing(2),
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
    },
  },
  head: {
    "justify-content": "space-between",
    display: "inline",
  },
  h1: {
    display: "inline",
  },
  image: {
    maxWidth: "400px",
  },
  container: {
    "padding-top": theme.spacing(14),
  },
  Card: {
    // minWidth: 300,
    margin: "20px",
  },
}));

function Contacts() {
  const classes = useStyles();

  return (
    <>
        <AppBar />
      <Container className={classes.container}>
        <Typography variant="h5">
          Все права на использование платформы mt.spbstu.ru принадлежат Фонду
          поддержки и развития инноваций «Политех». Стоимость использования
          платформы определяется в индивидуальном порядке в зависимости от срока
          использования и количества приобретаемых аккаунтов. По вопросам
          использования платформы обращаться по почте klimin_ai@spbstu.ru 
        </Typography>
        <Typography variant="h5" style={{marginTop: "40px"}}>
        All
          rights to use the mt.spbstu.ru platform belong to the "Politech"
          Innovation Support and Development Foundation. The cost of using the
          platform is determined individually depending on the period of use and
          the number of purchased accounts. If you have any questions about
          using the platform, please contact klimin_ai@spbstu.ru.
        </Typography>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => state.contacts;
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actions,
      push,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
